import { randomNumber } from "./util/random";
import getColor from "./util/color";

const RING_RADIUS = 100;
const SPAWN_DISTANCE = 3;

const getOrbitSpeedFactor = () => Math.random() * randomNumber(100, 1000) + 160;
const getRandomHex = () =>
  "#" + Math.floor(Math.random() * 16777215).toString(16);

const getColorWheel = () => getColor().hex();
const getParticleColor = () =>
  Math.random() > 0.1 ? `rgba(255, 255, 255, 1)` : `rgba(255, 255, 255, 0.3)`;

// const Particle = function Particle({ ringRadius = RING_RADIUS }) {
export default class Particle {
  constructor({ ringRadius = RING_RADIUS }) {
    // rgba(100, 60, 255, 1)
    // this.color = getColorWheel();
    this.color = getParticleColor();

    this.size = Math.random() * 5;
    this.ring = Math.random() * ringRadius * SPAWN_DISTANCE;

    this.orbitSpeed = getOrbitSpeedFactor();
    this.move = (Math.random() * 4 + 1) / this.orbitSpeed;
    this.random = Math.random() * 7;

    this.x = Math.cos(Math.random() * 7 + Math.PI) * ringRadius;
    this.y = Math.sin(Math.random() * 7 + Math.PI) * ringRadius;

    // return this;
  }
}

export const resetParticle = (particle, ringRadius) => {
  particle.ring = Math.random() * ringRadius * SPAWN_DISTANCE;
  particle.size = Math.random() * 5;
};

export const checkParticle = (particle, ringRadius) => {
  if (particle.size < 0.8) {
    resetParticle(particle, ringRadius);
  }

  particle.size *= 0.994;
};

export const moveParticle = (particle, ringRadius, direction = 1) => {
  particle.ring = Math.max(particle.ring - 1, ringRadius);
  particle.random += particle.move;

  particle.x = direction * Math.cos(particle.random + Math.PI) * particle.ring;
  particle.y = Math.sin(particle.random + Math.PI) * particle.ring;
};

export const drawParticle = (particle, ctx) => {
  // console.log("[space.draw] particle: ", particle);
  const { color, x, y, size } = particle;

  ctx.beginPath();
  ctx.fillStyle = color;
  ctx.arc(x, y, size, 0, Math.PI * 2);
  ctx.fill();
};
